export default "/assets/webpack-assets/GT-Walsheim-Pro-Medium.a5e7e8d17cc1051a33e3d2639395397a.ttf";